import { Injectable, Injector, inject, runInInjectionContext, effect } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { DropdownService } from 'src/utils/dropdown.service';

@Injectable({ providedIn: 'root' })
export class DropdownRegistryService {
  private dropdownService = inject(DropdownService);
  private injector = inject(Injector);

  private subject = new BehaviorSubject<string | null>(null);
  openId$: Observable<string | null> = this.subject.asObservable();

  constructor() {
    runInInjectionContext(this.injector, () => {
      effect(() => {
        const id = this.dropdownService.getOpenDropdown()();
        this.subject.next(id);
      });
    });
  }

  setOpen(id: string | null) {
    if (id === null) {
      this.dropdownService.closeDropdown();
    } else {
      this.dropdownService.openDropdownDirect(id);
    }
  }

  closeAll() {
    this.dropdownService.closeDropdown();
  }
}
